import axios from "axios";
import jsonp from "jsonp";

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
axios.defaults.withCredentials = true;

import {
  ServiceConfig,
  SgsConfig,
  Geoesbmengine,
  Map,
  DFC,
  GeoEntity,
  Quota,
  Serpool,
  IcacheMap,
  Archive,
  Gateway,
  SdmmetaData,
  logBehavior,
  archive
} from "./../config/app-config.js";
import querystring from "querystring";
export const ArchiveService = archive.location + "/services";
const GeoesbService = Geoesbmengine.location + "/services";
const MapService = Map.location + "/services";
const DFCService = DFC.location + "/services";
const GeoEntityService = GeoEntity.location + "/services";
const QuotaService = Quota.location + "/services";
const SerpoolService = Serpool.location + "/services";
const StreetScapeService = APPCONFIG.StreetHost + "/vista/services";
const metadataBaseUrl =
  APPCONFIG.IP + "/sdmmetadata/metadatarel/metaserviceinfo";
const GatewayService = Gateway.location + "/services";
const SdmmetaDataUrl = SdmmetaData.location + "/metadatarel";
const logBehaviorUrl = logBehavior.location;

//通用post请求
export const apiPost = (url, param) => {
  return axios({
    method: "post",
    data: param,
    url: url
  });
};

//根据资源id获取服务id
export const apiGetServiceIdByResource = (param, resid) => {
  var url = `${GeoesbService}/resource/${resid}.json`;
  return axios({
    method: "post",
    data: param,
    url: url
  });
};
//获取资源
export const apiGetResource = resId => {
  return axios.get(`${GeoesbService}/resource/data/resinfo/${resId}.json`);
};
//资源申请
export const resourceapply = resIdArry => {
  return axios.post(`${GeoesbService}/resourceapply.json`, resIdArry);
};
//元数据模板
export const apiMetadataTemplate = () => {
  // return axios.get(`${SgsConfig.MetadataTemplate}`)
  return axios.get(
    `${APPCONFIG.SgsHost}/skywebframe/cdn/xml/res-metadata-template.xml`
  );
  // return axios.get("https://localhost:3000/static/res-metadata-template.xml")
};

//添加服务
export const apiRegisterService = (serviceId, metadata) => {
  var url = `${GeoesbService}/resource/${serviceId}/null/metadata.xml`;
  return axios({
    method: "post",
    data: metadata,
    url: url,
    headers: {
      "Content-Type": "application/xml"
    }
  });
};
//获取地图
export const getMaps = param => {
  return axios.get(`${ServiceConfig.getMap}`, {
    params: param || {}
  });
};
//行政区划节点树
export const apiGetInterfaceType = id => {
  return axios.get(`${GeoesbService}/servicetype/${id}/interfacetype.json`);
};
//获取子分类
export const getSpecials = id => {
  return axios.get(`${ServiceConfig.catalogSpecials}.json?pkid=${id}`);
};

//获取指定ID的专题目录信息
export const getCatalogSpecial = id => {
  return axios.get(`${ServiceConfig.catalogSpecial}/${id}`);
};

//获取sfs请求
export const getSfsData = (url, param) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${url}?`, {
    params: param || {}
  });
};

//发送url请求元数据
export const getMetaData = url => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${url}`);
};
//获取图层原始地址
export const getOriginUrl = ID => {
  return axios.get(`${GeoesbService}/service/originUrl/${ID}.json`);
};
//获取模型列表
export const getSymbol = () => {
  return axios.get(`${ServiceConfig.Planconmanage}/sys/queryAll.json`);
};

//上传模型
export const postSymbol = param => {
  return axios({
    method: "post",
    url: `${ServiceConfig.Planconmanage}/sys/uploadArchive.json`,
    data: param
  });
};

//导出Excel
export const getExcelExport = param => {
  return axios({
    method: "post",
    data: param,
    url: `${ServiceConfig.Planconmanage}/seo/exportExl`
  });
};

//资源目录树操作
export const getServiceList = (
  resID,
  options,
  option,
  onsucc,
  onfail,
  onerror,
  formattype,
  serviceType
) => {
  var url = `${SgsConfig.GetServiceNodes}/${resID}.json`;
  url += "?" + "type=" + formattype; //目录规则
  url += "&" + "itypes=" + option.itypes; //接口类型
  if (options) {
    var catalogInfoKey = options.catalogNodeInfo.catalogType.value;
    url +=
      "&" +
      "catalogInfo=" +
      catalogInfoKey +
      ":" +
      options.catalogNodeInfo.catalogCode; //当前目录信息
    if (
      options.parentCategoryNodeInfos != null &&
      options.parentCategoryNodeInfos.length > 0
    ) {
      url += "&" + "parGategoryCatalog=";
      var parGategoryCatalog = "";
      for (var i = 0; i < options.parentCategoryNodeInfos.length; i++) {
        var parGategoryCatalogKey =
          options.parentCategoryNodeInfos[i].catalogType.value;
        parGategoryCatalog +=
          parGategoryCatalogKey +
          ":" +
          options.parentCategoryNodeInfos[i].catalogCode;
        if (i != options.parentCategoryNodeInfos.length - 1) {
          parGategoryCatalog += ",";
        }
      }
      url += parGategoryCatalog;
    }
  }

  return axios({
    method: "get",
    url: url
  });
};

export const getCatalogNodes = (
  options,
  option,
  onsucc,
  onfail,
  onerror,
  formattype,
  serviceType
) => {
  var url = `${SgsConfig.GetCatalogNodes}`;
  url += "?" + "type=" + formattype; //目录规则
  url += "&" + "itypes=" + option.itypes; //接口类型
  if (options) {
    url +=
      "&" +
      "catalogInfo=" +
      options.catalogNodeInfo.catalogType.value +
      ":" +
      options.catalogNodeInfo.catalogCode; //当前目录信息
    if (
      options.parentCategoryNodeInfos != null &&
      options.parentCategoryNodeInfos.length > 0
    ) {
      url += "&" + "parGategoryCatalog=";
      var parGategoryCatalog = "";
      for (var i = 0; i < options.parentCategoryNodeInfos.length; i++) {
        var parGategoryCatalogKey =
          options.parentCategoryNodeInfos[i].catalogType.value;
        parGategoryCatalog +=
          parGategoryCatalogKey +
          ":" +
          options.parentCategoryNodeInfos[i].catalogCode;
        if (i != options.parentCategoryNodeInfos.length - 1) {
          parGategoryCatalog += ",";
        }
      }
      url += parGategoryCatalog;
    }
  }
  return axios({
    method: "get",
    url: url
  });
};

export const getResourceNodes = (
  options,
  option,
  onsucc,
  onfail,
  onerror,
  formattype,
  serviceType
) => {
  var url = `${SgsConfig.GetResourceNodes}`;
  url += "?" + "type=" + formattype; //目录规则
  url += "&" + "itypes=" + option.itypes; //接口类型
  if (options) {
    url +=
      "&" +
      "catalogInfo=" +
      options.catalogNodeInfo.catalogType.value +
      ":" +
      options.catalogNodeInfo.catalogCode; //当前目录信息
    if (
      options.parentCategoryNodeInfos != null &&
      options.parentCategoryNodeInfos.length > 0
    ) {
      url += "&" + "parGategoryCatalog=";
      var parGategoryCatalog = "";
      for (var i = 0; i < options.parentCategoryNodeInfos.length; i++) {
        var parGategoryCatalogKey =
          options.parentCategoryNodeInfos[i].catalogType.value;
        parGategoryCatalog +=
          parGategoryCatalogKey +
          ":" +
          options.parentCategoryNodeInfos[i].catalogCode;
        if (i != options.parentCategoryNodeInfos.length - 1) {
          parGategoryCatalog += ",";
        }
      }
      url += parGategoryCatalog;
    }
  }
  return axios({
    method: "get",
    url: url
  });
};

export const getGetSpecialCatalog = param => {
  return axios.get(`${SgsConfig.GetSpecials}`, {
    params: param || {}
  });
};
export const getRootCode = () => {
  return axios.get(`${SgsConfig.GetRootCode}`);
};
export const getTradeCatalog = code => {
  return axios.get(`${SgsConfig.GetTradeCatalog}/${code}.json?current=true`);
};
export const getTradeResource = (code, param) => {
  return axios.get(`${SgsConfig.GetTradeResource}`, {
    params: {
      code: code,
      current: true
    }
  });
};

export const getCatalogFormt = () => {
  return axios.get(`${SgsConfig.GetCatalogFormt}`);
};

//规划资料获取子目录接口
export const apiGetSubCatalogInfo = param => {
  return axios.get(`${ArchiveService}/archive/manage/findList.json`, {
    params: param || {}
  });
};
//资源树查询
export const searchResource = param => {
  return axios.get(`${SgsConfig.SearchResource}`, {
    params: param || {}
  });
};
//资源树的搜索历史数据查询
export const apiSearchResourceHistory = param => {
  return axios.get(`${SgsConfig.SearchResourceHistory}`, {
    params: param || {}
  });
};
//资源树的搜索历史数据查询
export const apiSearchResourceHot = param => {
  return axios.get(`${SgsConfig.SearchResourceHot}`, {
    params: param || {}
  });
};
//资源树的相关推荐服务
export const apiResourceRecommend = param => {
  return axios({
    method: "post",
    url: `${SgsConfig.SearchResourceRecommend}`,
    data: param,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
  });
};
//资源树的历史数据删除
export const apiSearchResourceHistoryDelete = () => {
  return axios.delete(`${SgsConfig.SearchResourceHistoryDelete}`);
};
export const searchFullResource = param => {
  return axios.get(
    `${SgsConfig.SearchFullResource}.json?includeService=false`, {
    params: param || {}
  }
  );
};

/*
获取资源根节点
*/
export const getRootTheme = () => {
  return axios.get(`${SgsConfig.GetRootTheme}`);
};

export const getChildTheme = id => {
  return axios.get(`${SgsConfig.GetChildTheme}/${id}.json?datacount=true`);
};

export const apiGetUserInfo = () => {
  return axios.get(`${GeoesbService}/servicemanager/user/current.json`);
};
// 1. 获取tgt
export const apiLogin = () => {
  // return axios.post(SgsConfig.ticket,querystring.stringify({
  //         username: username,
  //         password: password
  //     }))
  return axios.get(SgsConfig.ticket)
}
// 2. 申请ST
export const apiSTForSite = (TGT, site) => {
  return axios.post(`${SgsConfig.ticket}/${TGT}`,querystring.stringify({
          service:site
      }))
}
// 3. 验证st，建立信任关系
export const apiCasCall = (site, ST) => {
  return axios({
      method: 'get',
      url: site,
      params: {'ticket': ST},
  })
}
//获取模块
export const apiGetModulesByUserId = userId => {
  return axios.get(`${GeoesbService}/module/permis/${userId}.json`);
};
// export const apiBaseMap = id => {
//   return new Promise((resolve, reject) => {
//     jsonp(
//       `${MapService}/map/manager/query.jsonp?pageindex=1&pageSize=1000&userid=${id}`,
//       (err, data) => {
//         if (err) {
//           reject(err);
//         } else {
//           resolve(data);
//         }
//       }
//     );
//   });
// };
export const apiBaseMap = id => {
  return new Promise(async (resolve, reject) => {
    try {
      let res = await axios.get(`${MapService}/map/manager/query?pageindex=1&pageSize=1000&userid=${id}`)
      resolve(res.data)
    } catch (error) {
      reject(error)
    }
  });
};

export const apiAddBaseMap = param => {
  return axios({
    method: "post",
    url: `${MapService}/map/manager/add.json`,
    data: param
  });
};

export const updateBaseMap = param => {
  return axios({
    method: "put",
    url: `${MapService}/map/manager/update.json`,
    data: param
  });
};

export const apiDeleteBaseMap = param => {
  return axios({
    method: "delete",
    url: `${MapService}/map/manager/remove/` + param + `.json`
  });
};

export const apiExportExecl = param => {
  return axios({
    method: "post",
    url: `${MapService}/file/export/execl.json`,
    data: param
  });
};

//按资源ID查询服务
export const apiServiceCatalogByResID = id => {
  return axios.get(`${GeoesbService}/resource/serinfo/interfaces/${id}.json`, {
    showall: false
  });
};

// 根据serviceId获取资源导出权限
export const apiMetaInfoByServiceId = id => {
  return axios.get(`${SdmmetaDataUrl}/metaserviceinfo/serviceid/${id}.json`, {
    showall: false
  });
};

// 根据resourceId获取资源导出权限
export const apiMetaInfoByMetadataId = id => {
  return axios.get(`${SdmmetaDataUrl}/metaserviceinfo/metadataid/${id}.json`, {
    showall: false
  });
};

// 根据resourceId获取资源导出权限
export const apiMetaInfoByResourceId = id => {
  return axios.get(`${SdmmetaDataUrl}/metaserviceinfo/resourceid/${id}.json`, {
    showall: false
  });
};

// 导出信息写入日志
export const apiLogBehavior = param => {
  return axios.get(
    `${logBehaviorUrl}/skygeoesbmengine/services/log/behaviorStat/fiddlerBehavior.json`, {
    params: param || {}
  }
  );
};

// export const apiServiceCatalogByResID = (function() {
//   let _promiseCache = {};
//   return function(id) {
//     if (!_promiseCache[id]) {
//       _promiseCache[id] = axios.get(`${GeoesbService}/resource/serinfo/interfaces/${id}.json`, {
//         showall: false
//       });
//     }
//     return _promiseCache[id];
//   }
// }())

//查询服务时间
export const apiServiceCatalogVersionByID = (id, key) => {
  return axios.get(
    `${GeoesbService}/resource/serinfo/versions/${id}/${key}.json`, {
    showall: false
  }
  );
};

//查询服务信息
// export const apiServiceCatalogServiceByID = (id) => {
//   return axios.get(`${GeoesbService}/resource/data/serinfo/${id}.json`, {
//     flag: 1
//   })
// }

//查询资源下所有服务
export const apiServiceCatalogServiceByID = id => {
  return axios.get(`${GeoesbService}/resource/data/serinfo/${id}.json`, {
    flag: 1
  });
};
//申请元数据
export const applyMetaDataPri = (userid, param) => {
  return axios({
    method: "post",
    url: `${GeoesbService}/servicemanager/apply/apply/userid/${userid}/restype/9`,
    data: [param]
  });
};
//删除服务
export const apiDeleteServiceByID = sid => {
  var random = "?random=" + Math.random();
  var url = `${GeoesbService}/resource/data/serinfo/${sid}.json` + random;
  return axios({
    method: "delete",
    url: url
  });
};
// export const apiServiceCatalogServiceByID = (function (id) {
//   return axios.get(`${GeoesbService}/resource/data/serinfo/${id}.json`, {
//     flag: 1
//   })
// })

export const apiServiceLayerServiceByID = id => {
  return axios.get(`${SgsConfig.getStyleLayer}/${id}`);
};

export const apiSMRESTMAPCapality = (function () {
  let _promiseCache = {};
  return function (param) {
    if (!_promiseCache[param.url]) {
      _promiseCache[param.url] = axios.get(`${GeoesbService}/servicanalysis/SMRESTMAP/capality.json`, {
        params: param || {}
      });
    }
    return _promiseCache[param.url];
  };
})();

export const apiWMS111Capality = (function () {
  let _promiseCache = {};
  return function (param) {
    if (!_promiseCache[param.url]) {
      _promiseCache[param.url] = axios.get(`${GeoesbService}/servicanalysis/WMS111/capality.json`, {
        params: param || {}
      });
    }
    return _promiseCache[param.url];
  };
})();

export const apiWMS130Capality = (function () {
  let _promiseCache = {};
  return function (param) {
    if (!_promiseCache[param.url]) {
      _promiseCache[param.url] = axios.get(`${GeoesbService}/servicanalysis/WMS130/capality.json`, {
        params: param || {}
      });
    }
    return _promiseCache[param.url];
  };
})();

export const apiWMTSCapality = (function () {
  let _promiseCache = {};
  return function (param) {
    if(param.url.indexOf(APPCONFIG.initIpPort>0)){
      param.url = param.url.replace(APPCONFIG.initIpPort,APPCONFIG.updateIpPort);
    }
    if (!_promiseCache[param.url]) {
      _promiseCache[param.url] = axios.get(`${GeoesbService}/servicanalysis/WMTS100/capality.json`, {
        params: param || {}
      });
    }
    return _promiseCache[param.url];
  };
})();

//获取固定比例尺restMap的源数据信息
export const apiCapality = url => {
  // return axios.get(url + '.json')
  return axios.get(url);
};

export const apiServiceMetadata = (function () {
  let _promiseCache = {};
  return function (serviceId) {
    if (!_promiseCache[serviceId]) {
      _promiseCache[serviceId] = axios.get(
        `${GeoesbService}/resource/metadata/serinfo/${serviceId}.xml`
      );
    }
    return _promiseCache[serviceId];
  };
})();

export const apiResourceMetadata = (function () {
  let _promiseCache = {};
  return function (resourceId) {
    if (!_promiseCache[resourceId]) {
      _promiseCache[resourceId] = axios.get(
        `${GeoesbService}/resource/metadata/resinfo/${resourceId}.xml`
      );
    }
    return _promiseCache[resourceId];
  };
})();

//根据资源id查询 元数据信息和服务信息
export const apiResourceMetadataByResid = (function () {
  let _promiseCache = {};
  return function (resourceid) {
    if (!_promiseCache[resourceid]) {
      _promiseCache[resourceid] = axios.get(
        `${metadataBaseUrl}/resourceid/${resourceid}`
      );
    }
    return _promiseCache[resourceid];
  };
})();

export const apiBufferService = param => {
  param = Object.assign({
    endType: "ROUND",
    leftDistance: 5,
    rightDistance: 5,
    type: "geojson",
    semicircleLineSegment: 10
  },
    param
  );
  // return axios.post(`${ServiceConfig.httpproxy}?url=${DFCService}/analyst/buffer.json?`, { data: JSON.stringify(param) });
  return axios({
    method: "post",
    url: `${ServiceConfig.httpproxy}?url=${DFCService}/analyst/buffer.json`,
    data: JSON.stringify(param)
  });
};
export const apiGetMetaDataByResourceNAME = param => {
  // return axios.post(`${ServiceConfig.httpproxy}?url=${DFCService}/analyst/buffer.json?`, { data: JSON.stringify(param) });
  return axios({
    method: "post",
    url: `https://192.168.10.101:8080/sdmmetadata/metadata/findbyparameter`,
    params: param
  });
};
//新版地名地址匹配
export const fuzzyAddressNew = (param, url) => {
  return axios({
    method: "post",
    url: url, //`${ServiceConfig.httpproxy}?url=` + url + "?",
    params: param,
    data: []
  });
};

//新版地名地址逆向匹配
export const reverseMatchNew = (param, url) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=` + url + "?", {
    params: param || {}
  });
};
//老版地名地址匹配
export const fuzzyAddress = (param, url) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=` + url + "?", {
    params: param || {}
  });
};

//老版地名地址逆向匹配
export const reverseMatch = (param, url) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=` + url + "?", {
    params: param || {}
  });
};
//路径分析
export const IPathAnalysis = (param, url) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=` + url + "?", {
    params: param || {}
  });
};
//获取空间信息
export const getDistrict = code => {
  return axios.get(`${GeoEntityService}/district/${code}.json`);
};

//获取下级区划目录
export const getChildDistrict = param => {
  return axios.get(`${GeoEntityService}/district/entity.json`, {
    params: param || {}
  });
};

//设置地图显示范围
export const updateMap = param => {
  return axios.put(`${MapService}/map/manager/update.json`, param);
};

export const apiServiceOriginUrl = id => {
  return axios.get(`${GeoesbService}/service/originUrl/${id}.json`);
};

export const apiScenesList = sceneUrl => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${sceneUrl}/scenes.json`);
};

export const apiProxyUrl = (function () {
  let _promiseCache = {};
  return function (url, params) {
    if (!_promiseCache[url]) {
      _promiseCache[url] = axios.get(`${ServiceConfig.httpproxy}?url=${url}`, {
        params: params || {}
      });
    }
    return _promiseCache[url];
  };
})();

//获取模块
export const getModules = url => {
  return axios.get(`${GeoesbService}/${url}`);
};

export const apicurStyle = () => {
  return axios.get(`${GeoesbService}/customstyle/style/cur.json`);
};
//地图定制相关接口
export const addStyleLayer = param => {
  return axios.post(SgsConfig.StyleLayer, param);
};
export const updateStyleLayer = param => {
  return axios.put(SgsConfig.StyleLayer, param);
};
export const getThemeByServiceId = id => {
  return axios.get(SgsConfig.getStyleLayer + "/" + id);
};
export const getThemesByServiceIds = serviceList => {
  //根据服务数组查询多个专题图层
  let promiseAll = serviceList.map(function (service) {
    return axios.get(SgsConfig.getStyleLayer + "/" + service.id);
  });
  return axios.all(promiseAll);
};
export const addStyleMap = param => {
  return axios.post(SgsConfig.StyleMap, param);
};
export const updateStyleMap = param => {
  return axios.put(SgsConfig.StyleMap, param);
};
export const getStyleMapById = id => {
  return axios.get(SgsConfig.StyleMap + "/" + id);
};
export const getStyleMap = param => {
  return axios.post(SgsConfig.StyleMap + "/list", param);
};
export const deleteStyleMap = id => {
  return axios.delete(SgsConfig.StyleMap + "/" + id);
};
export const getSfsData_ = (url, param) => {
  return axios.get(url + "?", { params: param });
};
export const deleteSettle = pkid => {
  return axios.delete(SgsConfig.StyleLayer + "/" + pkid);
};
/**
 * 根据用户ID获取消息 （定时请求，2s一次）
 * @param userId
 * @returns {AxiosPromise<T>}
 */
export const getUserMessage = () => {
  return axios.get(
    `${GeoesbService}/messages.json?pagesize=1&pageindex=1&status=0`
  );
};

/**
 * 根据数据源ID获取所有的数据集信息
 * @param param
 * @returns {AxiosPromise<T>}
 */
export const getDatasetsByDatasourceId = param => {
  return axios.get(`${SgsConfig.getDatasetsByDataSourceId}`, {
    params: param || {}
  });
};

export const serachDatasetInfoByName = param => {
  return axios.get(`${SgsConfig.getDatasetInfoByDatasetName}`, {
    params: param || {}
  });
};

/**
 * 获取实体目录根节点
 */
export const apiGetEntityRoot = () => {
  return axios.get(
    `${GeoesbService}/servicemanager/datacatalog/tree/ENTITY.json`
  );
};

export const apiGetEntityRelation = id => {
  return apiProxyUrl(
    `${SerpoolService}/service/reldataset.json?datasetid=${id}`
  );
};

export const getTileFeature = (url, param) => {
  return axios.get(url + "/tileFeature.rjson?", {
    params: param || {}
  });
};

//获取多个服务ID的服务
export const apiGetServiceByIds = param => {
  return axios.get(`${GeoesbService}/service/getServiceByIds.json`, {
    params: param || {}
  });
};

export const apiGetResourceRel = (function () {
  let _promiseCache = {};
  return function (resourceId, cache) {
    if (!cache) {
      return axios.get(
        `${GeoesbService}/resourcerel/getresourcerel/${resourceId}.json`
      );
    }
    if (!_promiseCache[resourceId]) {
      _promiseCache[resourceId] = axios.get(
        `${GeoesbService}/resourcerel/getresourcerel/${resourceId}.json`
      );
    }
    return _promiseCache[resourceId];
  };
})();

export const apiUpdateResouceRel = params => {
  return axios({
    method: "put",
    url: `${GeoesbService}/resourcerel.json`,
    data: params || {}
  });
};

export const apiAddResouceRel = params => {
  return axios({
    method: "post",
    url: `${GeoesbService}/resourcerel.json`,
    data: params || {}
  });
};

export const apiDeleteResourceRel = id => {
  return axios({
    method: "delete",
    url: `${GeoesbService}/resourcerel/${id}.json`
  });
};

export const apiGetQutoaServiceRel = (function () {
  let _promiseCache = {};
  return function (id) {
    if (!_promiseCache[id]) {
      _promiseCache[id] = axios.get(
        `${QuotaService}/indicator/${id}/relinfo.json`
      );
    }
    return _promiseCache[id];
  };
})();

//添加地图打印
export const addMapPrint = params => {
  return axios({
    method: "post",
    url: `${GeoesbService}/servicemanager/mapprint.json`,
    data: params || {}
  });
};

//单个删除地图打印记录
export const deleteMapPrint = id => {
  return axios({
    method: "delete",
    url: `${GeoesbService}/servicemanager/mapprint/${id}.json`
  });
};

//批量删除地图打印记录
export const deleteMapPrints = ids => {
  return axios({
    method: "delete",
    url: `${GeoesbService}/servicemanager/mapprint.json`,
    data: ids || []
  });
};

//删除当前用户下所有打印记录
export const deleteAllMapPrintsByUserId = userId => {
  return axios({
    method: "delete",
    url: `${GeoesbService}/servicemanager/mapprint/all/${userId}.json`
  });
};

//分页获取当前用户的地图打印记录
export const getMapPrintsByUser = param => {
  let str = "";
  Object.keys(param).forEach(item => {
    if (param[item] && item != "userId") {
      str += `&${item}=${param[item]}`;
    }
  });
  return axios({
    method: "get",
    url: `${GeoesbService}/servicemanager/mapprint/infos/${param.userId}.json?${str}`
  });
};

//获取地图打印成果文件
export const getMapPrintFileExport = mapPrintId => {
  return `${GeoesbService}/servicemanager/mapprint/file/${mapPrintId}.json`;
};

//获取地图打印成果预览图
export const getMapPrintPreview = mapPrintId => {
  return `${GeoesbService}/servicemanager/mapprint/preview/${mapPrintId}.json`;
};

//添加地图收藏
export const addFavor = params => {
  return axios({
    method: "post",
    url: `${GeoesbService}/servicemanager/bookmark.json`,
    data: params || {}
  });
};

//删除地图收藏
export const deleteFavor = id => {
  return axios({
    method: "delete",
    url: `${GeoesbService}/servicemanager/bookmark/${id}.json`
  });
};

//获取地图收藏
export const getFavor = id => {
  return axios({
    method: "get",
    url: `${GeoesbService}/servicemanager/bookmark/${id}.json`
  });
};

//获取目录下的地图收藏
export const getCatalogFavor = id => {
  return axios({
    method: "get",
    url: `${GeoesbService}/servicemanager/bookmarkcatalog/tree/${id}.json`
  });
};

//获取地图收藏目录根节点
export const getFavorCatalogRoot = () => {
  return axios({
    method: "get",
    url: `${GeoesbService}/servicemanager/bookmarkcatalog/root.json`
  });
};

//删除地图收藏目录
export const delFaverCatalog = id => {
  return axios({
    method: "delete",
    url: `${GeoesbService}/servicemanager/bookmarkcatalog/${id}.json`
  });
};

//添加地图收藏目录
export const addFaverCatalog = param => {
  return axios({
    method: "post",
    url: `${GeoesbService}/servicemanager/bookmarkcatalog.json`,
    data: param || {}
  });
};

//获取当前用户所有地图收藏
export const getAllFavor = () => {
  return axios({
    method: "get",
    url: `${GeoesbService}/servicemanager/bookmark/all.json`
  });
};

//
export const apiTranSpitalFileToGeoJson = params => {
  return axios({
    method: "post",
    url: `${DFCService}/spatial/transGeoJson.json`,
    data: params || {}
  });
};

export const apiGenerateSpatilFile = param => {
  return axios({
    method: "post",
    url: `${DFCService}/spatial/transSpitalFile.json`,
    data: param
  });
};

export const uploadSurveyCoordinates = param => {
  return axios.post(`${GeoesbService}/surveypoint/transGeojson.json`, param, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

export const apiTransformFile = param => {
  return axios({
    method: "post",
    url: `${DFCService}/spatial/transformZip.json`,
    data: param
  });
};

export const apiGetPrjCoordSys = param => {
  return axios({
    method: "post",
    url: `${DFCService}/spatial/getPrjCoordSys.json`,
    data: param
  });
};

//查询坐标系列表
export const apiPrjCoordSysList = param => {
  return axios.get(`${DFCService}/spatial/prjCoordSysList.json`);
};

/**
 * geojson坐标转换
 * @param param: transfromName--目标坐标名称，targetEpsgcode--目标坐标系的epsgcode，method--转换方法，sourceProjectName--源坐标名称，geojson--geojson字符串，
 * transfromName与targetEpsgcode如果同时传，则会根据targetEpsgcode转换
 * {
 *   transfromName: '',
 *   targetEpsgcode: ''
 *   method: '',
 *   sourceProjectName:'',
 *   geojson: '{"type":"FeatureCollection","features":[]}'
 * }
 */
export const apiTransGeojsonPrj = param => {
  return axios({
    method: "post",
    url: `${DFCService}/spatial/transGeojsonPrj.json`,
    data: param
  });
};

//热点数据
export const getHotData = param => {
  return axios.get(`${GeoesbService}/log/system/topchart/services.json`, {
    params: param
  });
};

// 街景-获取道路线名称
// params = {lon=499092.8721651909&lat=306000.9780488882}
export const getRoadName = params => {
  return axios({
    method: "get",
    url: `${StreetScapeService}/roadline/roadname`,
    params: params
  });
};

// 街景-获取街景点ID
// params = {lon=499091.4196120561&lat=306193.2367723207&distance=300}
// distance：缓冲半径
export const getPanoID = params => {
  return axios({
    method: "get",
    url: `${StreetScapeService}/pano/panoid`,
    params: params
  });
};
export const getCastCoords = params => {
  return axios({
    method: "get",
    url: `${StreetScapeService}/cast`,
    params: params
  });
};

// 获取wms服务元数据
export const getwmsmetadata = url => {
  return axios({
    method: "get",
    url: url,
    withCredentials: false
  });
};
//----------------geoCoding modify-----------------------------
export const getWordSplit = addr => {
  return axios.get(
    `${APPCONFIG.GeoCodingHost}/dfc/services/aigeocoding/manager/dicdata/splitSingle?addr=${addr}`
  );
};

export const getReverseAddr = param => {
  return axios.get(
    `${APPCONFIG.GeoCodingHost}/dfc/services/geocoding/matching/reverse?x=${param.x}&y=${param.y}&random=${param.random}`
  );
};
export const submitDatas = param => {
  return axios.post(
    `${APPCONFIG.GeoCodingHost}/dfc/services/geocoding/modify/add`,
    param
  );
};
//----------------dfc geoCoding micro service-----------------------------
export const getReverseAddrByMicro = param => {
  return axios.get(
    `${APPCONFIG.GeoCodingHost}/dfc/geocoding/services/reverse?top=${param.top}&x=${param.x}&y=${param.y}&random=${param.random}`
  );
};
export const submitDatasByMicro = param => {
  return axios.post(
    `${APPCONFIG.GeoCodingHost}/dfc/geocoding/services/modify/add`,
    param
  );
};
//数据中心-上传本地数据集-智能缓存切图相关接口
export const apiGetDFCUploadFileList = param => {
  return axios.get(`${GeoesbService}/servicemanager/mapupload/list.json`, {
    params: param || {}
  });
};

export const apiupdateDFCUploadFileList = param => {
  return axios({
    method: "put",
    url: `${GeoesbService}/servicemanager/mapupload/update.json`,
    //url: `https://127.0.0.1:8080/geoesbmengine/services/servicemanager/mapupload/update.json`,
    data: param
  });
};

export const apiDFCuploadFile = param => {
  return axios({
    method: "post",
    url: `${GeoesbService}/servicemanager/mapupload/upload.json`,
    data: param
  });
};

export const apiDFCUploadRecord = param => {
  return axios({
    method: "post",
    url: `${GeoesbService}/servicemanager/mapupload/add.json`,
    data: param
  });
};

export const apiDeleteUploadFile = id => {
  return axios.delete(
    `${GeoesbService}/servicemanager/mapupload/remove/${id}.json`
  );
};

export const apiGetDFCUploadResult = (function () {
  let _promiseCache = {};
  return function (code) {
    if (!_promiseCache[code]) {
      _promiseCache[code] = axios.get(
        `${GeoesbService}/servicemanager/mapupload/content/${code}.json`
      );
    }
    return _promiseCache[code];
  };
})();

export const apiGetDFCUploadOriginalResult = (function () {
  let _promiseCache = {};
  return function (code) {
    if (!_promiseCache[code]) {
      _promiseCache[code] = axios.get(
        `${GeoesbService}/servicemanager/mapupload/content/original/${code}.json`
      );
    }
    return _promiseCache[code];
  };
})();

export const apiCutCacheMap = param => {
  return axios({
    method: "post",
    url: `${IcacheMap.location}/services/cacheMap/insertCacheMap.json`,
    data: querystring.stringify(param)
  });
};

export const apiCreateCachemapTask = mapid => {
  return axios.get(
    `${IcacheMap.location}/services/cacheTask/createTask/${mapid}.json`
  );
};

export const apiStartCacheMapTask = mapid => {
  return axios.get(
    `${IcacheMap.location}/services/cacheTask/manageCacheServer/${mapid}?method=startCacheTask`
  );
};

export const apiGetAreadyUploadChunks = params => {
  return axios.get(
    `${IcacheMap.location}/services/dataFile/getChunkedFileSize.json`, { params: params || {} }
  );
};

export const apiGetUpladedFileMatadata = params => {
  return axios.get(`${IcacheMap.location}/services/dataFile/parse.json`, {
    params: params,
    timeout: 1000 * 60 * 10
  });
};

export const apiMergeFile = params => {
  return axios.get(`${Archive.location}/services/archive/manage/merge`, {
    params: params || {}
  });
};

export const apiGetFileByIds = ids => {
  return axios.get(
    `${Archive.location}/services/archive/manage/findMulti/${ids}.json`
  );
};

export const apiRemoveCatalogAndFile = ids => {
  var url = `${Archive.location}/services/archive/manage/delete?pkids=${ids}`;
  return axios({
    method: "delete",
    url: url
  });
};

/**
 * 要素挂接api接口
 * @returns {*}
 */
//根据资源id获取要素挂接
export const apiElementLinkByResId = resid => {
  return axios.get(`${MapService}/elementlink/resource/${resid}.json`);
};

//新增要素挂接
export const apiAddElementLink = param => {
  return axios({
    method: "post",
    url: `${MapService}/elementlink/add.json`,
    data: param
  });
};

//删除要素挂接
export const apiDeleteElementLink = params => {
  return axios({
    method: "delete",
    url: `${MapService}/elementlink/remove.json`,
    params: params
  });
};

export const apiGetByUrl = url => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${url}.json`);
};

export const apiGetTsHistory = url => {
  return axios.get(`${url}`, {
    //解决访问mule接口跨域
    withCredentials: false
  });
};

export const apiGetLayerJson = url => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${url}/layers.json?`);
};

export const apiGetDistrictInfoByCode = code => {
  let url = `${GeoesbService}/servicemanager/district/code/${code}.json`;
  return axios.get(url);
};

export const apiDataExportFile = param => {
  return axios({
    method: "post",
    url: `${ServiceConfig.httpproxy}?url=${DFCService}/spatial/exportDs.json`,
    data: param,
    responseType: "blob"
  });
};

//个人目录
export const getPersonalCatalog = id => {
  return axios.get(
    `${GeoesbService}/servicemanager/datacatalog/find.json?userid=${id}`
  );
};

/**
 * 根据条件获取用户{pagesize: 10, pageindex: 1,depid:"",username:""};
 */
export const apiUserQueryUrl = (
  param = { pagesize, pageindex, depid, username }
) => {
  let str = "";
  Object.keys(param).forEach(item => {
    if (param[item]) {
      str += `&${item}=${param[item]}`;
    }
  });
  let url = `${GeoesbService}/servicemanager/user/query.json?${str}`;
  return axios.get(url);
};

// 根据资源id获取元数据信息和服务信息
export const getMetadataInfo = resourceId => {
  let url = `${metadataBaseUrl}/resourceid/${resourceId}.json`;
  return axios.get(url);
};
export const apiGetDistrictCatalog = params => {
  return axios.get(`${GeoesbService}/servicemanager/district/child.json`, {
    params: params || {}
  });
};
//根据id获取行政区划信息 apiGetDistrictInfoById
export const apiGetDistrictInfoById = districtid => {
  return axios.get(`${GeoesbService}/servicemanager/district/${districtid}.json`);
};
//获取专题目录
export const getSpecialCatalog = param => {
  return axios.get(`${GeoesbService}/servicemanager/special/child.json`, {
    params: param
  });
};
//根据行政区划name模糊查询
export const apiGetDistrictByName = params => {
  return axios.get(`${GeoesbService}/servicemanager/district/distname.json`, {
    params: params || {}
  });
};
//根据行政区划code获取区划中心点坐标geometry
export const apiGetDistrictGeocenter = districtcode => {
  return axios.get(`${GeoesbService}/area/geocenter/${districtcode}.json`);
};
//根据行政区划code获取区划中心点geometry
export const apiGetDistrictGeometry = districtcode => {
  return axios.get(`${GeoesbService}/area/geo/${districtcode}.json`);
};
// 最佳路径分析服务
export const apiGetRouteAnalysis = node => {
  return axios({
    method: "get",
    url: `${APPCONFIG.networkServiceUrl}/path.json?nodes=${node}&hasLeastEdgeCount=false&parameter=%7B"resultSetting":%7B"returnEdgeIDs":true,%20"returnNodeIDs":true,%20"returnPathGuides":true,%20"returnRoutes":true,%20"returnEdgeFeatures":true,%20"returnEdgeGeometry":true,%20"returnNodeFeatures":true,%20"returnNodeGeometry":true%7D,%20"weightFieldName":"SmLength"%7D`,
    withCredentials: false
  });
};

// 通过服务名称查找资源ID
export const getResourceIdByName = (name) => {
  return axios.get(`${GeoesbService}/resource/data/full?pageindex=1&pagesize=10&name=${name}`);
};

// 获取数据集信息
export const getDatasetInfo = (url) => {
  return axios.get(`${ServiceConfig.httpproxy}?url=${url}/layers.json`);
};


/**
 * 三维分析
 */
// 地质体查询
export const apiGeologyAnalysis = param => {
  return axios.post(`${APPCONFIG.geologicalConfigs.queryUrl}`, param, { withCredentials: false });
};

// 获取坡度
export const apiGetSlope = param => {
  return axios.get(`${APPCONFIG.SlopeUrl}/gridValue.json?x=${param.x}&y=${param.y}`, { withCredentials: false });
};

// 获取坡向
export const apiGetAspect = param => {
  return axios.get(`${APPCONFIG.AspectUrl}/gridValue.json?x=${param.x}&y=${param.y}`, { withCredentials: false });
};

// 叠加分析获取下拉框数据
export const apiGetOverlayAnalysis = param => {
  return axios.get(`${APPCONFIG.overlayAnalysisUrl}/datasets.json`, { withCredentials: false });
};

// 退线分析获取下拉框数据
export const apiGetRegressionAnalysis = param => {
  return axios.get(`${APPCONFIG.RegressionAnalysisUrl}/datasets.json`, { withCredentials: false });
};

// 退线分析缓冲区
export const apiRegressionAnalysisBuffer = param => {
  return axios.post(`${APPCONFIG.RegressionAnalysisUrl}/geometry/3d/buffer.json`, param, { withCredentials: false });
};

// 退线分析
export const apiRegressionAnalysis = param => {
  return axios.post(`${APPCONFIG.RegressionAnalysisUrl}/datasets/${param.source}/spatialquery3d.json`, param.params, { withCredentials: false });
};

// 缓冲区分析
export const apiBufferAnalysis = param => {
  return axios.post(`${APPCONFIG.BufferAnalysisUrl}/geometry/buffer.json`, param, { withCredentials: false });
};

// 地形开挖分析服务
export const apiExcavation = data => {
  return axios.post(`${APPCONFIG.ExcavationUrl}`, data, { withCredentials: false });
};

/**
 * 飞行路线
 */
// 获取飞行路线
export const apiGetFlightRoutes = () => {
  return axios.get(`${MapService}/flightroute/page.json?pageSize=9999`);
};

// 新增飞行路线
export const apiNewFlightRoutes = params => {
  return axios.post(`${MapService}/flightroute`, params);
};

// 编辑飞行路线
export const apiEditFlightRoutes = params => {
  return axios.put(`${MapService}/flightroute`, params);
};

// 删除飞行路线
export const apiRemoveFlightRoutes = pkid => {
  return axios.delete(`${MapService}/flightroute/${pkid}`);
};

/**
 * 图片图例挂接
 */
// 获取图片图例  restypeid 1是服务 0是资源
export const apiGetPictureLegends = (options) => {
  return axios.get(`${GeoesbService}/resources/${options.resID}/fmdataids?pageindex=${options.pageindex}&pagesize=${options.pagesize}&reltype=${options.reltype}&restypeid=1`);
};

// 获取部门根节点
export const apiGetRootDeptment = () => {
  return axios.get(`${GeoesbService}/servicemanager/department/root/get.json`);
};

//获取部门子节点
export const apiGetChildDeptment = (depId) => {
  return axios.get(`${GeoesbService}/servicemanager/department/child/${depId}.json`);
};



// WEBPACK FOOTER //
// ./src/apis/api.js